'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    contact: {
        deliveryAddress: {}
    },
    contactErrors: {
        hasErrors: false,
        hasClientErrors: false,
        hasServerErrors: false,
        clientErrors: { primary: {}, deliveryAddress: {} },
        serverErrors: { primary: {}, deliveryAddress: {}, general: {} }
    }
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = state;
    switch (action.type) {
        case _actionTypes2.default.SET_FORM_MODE:
            newState = (0, _extends3.default)({}, state, { contact: (0, _extends3.default)({}, state.contact, { mode: action.mode }) });
            break;
        case _actionTypes2.default.DISCARD_DELIVERY_ADDRESS:
            {
                newState = (0, _extends3.default)({}, state, { editingDeliveryAddress: null });
                break;
            }
        case _actionTypes2.default.EDIT_DELIVERY_ADDRESS:
            {
                newState = (0, _extends3.default)({}, state, { editingDeliveryAddress: action.address });
                break;
            }
        case _actionTypes2.default.SELECT_DELIVERY_ADDRESS:
            {
                newState = (0, _extends3.default)({}, state, { contact: (0, _extends3.default)({}, state.contact, { deliveryAddressId: action.id }) });
                break;
            }
        case _actionTypes2.default.CONTACT_CHANGE:
            newState = (0, _extends3.default)({}, state, { contact: (0, _extends3.default)({}, state.contact, action.contact) });
            if (!newState.contact.countryId) newState.contact.countryId = newState.contact.defaultCountryId;
            if (!newState.contact.deliveryAddress.countryId) newState.contact.deliveryAddress.countryId = newState.contact.defaultCountryId;
            break;
        case _actionTypes2.default.CONTACT_DISPLAY_ERRORS:
            {
                newState = (0, _extends3.default)({}, state, {
                    contactErrors: (0, _extends3.default)({}, state.contactErrors, action.data)
                });
                newState.contactErrors.hasErrors = newState.contactErrors.hasClientErrors || newState.contactErrors.hasServerErrors;
                break;
            }
    }
    return newState;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customer/reducer.js
// module id = 1043
// module chunks = 0